"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _utils = require("@alycecom/utils");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _currencies = require("../../Shared/store/currencies/currencies.selectors");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    root: {
      height: 48,
      padding: spacing(1.25, 2.25, 1.25, 1.25),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: 5,
      border: "1px solid ".concat(palette.grey.main)
    },
    flag: {
      width: 28,
      height: 28,
      borderRadius: 14
    }
  };
});

var ConversionResult = function ConversionResult(_ref2) {
  var fromCurrencyId = _ref2.fromCurrencyId,
      toCurrencyId = _ref2.toCurrencyId,
      resultPrice = _ref2.resultPrice,
      exchangeRate = _ref2.exchangeRate;
  var classes = useStyles();
  var fromCurrency = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _currencies.makeGetCurrencyById)(fromCurrencyId);
  }, [fromCurrencyId]));
  var toCurrency = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _currencies.makeGetCurrencyById)(toCurrencyId);
  }, [toCurrencyId]));
  var isLoading = (0, _reactRedux.useSelector)(_currencies.getIsLoading);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.root,
    "data-testid": "CurrencyConverter.ConversionResult.".concat(toCurrencyId)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "center"
  }, !isLoading && toCurrency && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, toCurrency.image && (0, _utils.isValidImage)(toCurrency.image) && /*#__PURE__*/_react.default.createElement("img", {
    src: toCurrency.image,
    alt: toCurrency.name,
    className: classes.flag
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 1.5
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Subcopy-Static"
  }, toCurrency.code), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Inactive",
    "data-testid": "CurrencyConverter.ConversionResult.".concat(toCurrencyId, ".Name")
  }, toCurrency.name))), isLoading && /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, {
    width: 80
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    textAlign: "right"
  }, !isLoading && fromCurrency && toCurrency && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Subcopy-Static"
  }, toCurrency.code, ' ', /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "CurrencyConverter.ConversionResult.".concat(toCurrencyId, ".Price")
  }, resultPrice)), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Inactive"
  }, "1 ", fromCurrency.code, " =", ' ', /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "CurrencyConverter.ConversionResult.".concat(toCurrencyId, ".ExchangeRate")
  }, exchangeRate.toFixed(2)), ' ', toCurrency.code)), isLoading && /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, {
    width: 60,
    "data-testid": "CurrencyConverter.ConversionResult.".concat(toCurrencyId, ".Loading")
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(ConversionResult);

exports.default = _default;